import { Injectable } from '@angular/core';
import { AnnualReward } from '@app/core/interfaces';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as fromAnnualReward from './annual-reward.actions';
import { AnnualRewardService } from './annual-reward.service';

@Injectable()
export class AnnualRewardEffects {

     loadAnnualReward$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(fromAnnualReward.LOAD),
        mergeMap(() => this.annualRewardService.loadAnnualReward$().pipe(
            map( (annualReward: AnnualReward) => new fromAnnualReward.LoadAnnualRewardSuccess({ annualReward })),
            catchError((errors) => of(new fromAnnualReward.LoadAnnualRewardError({ errors }))),
        )),
    ));

    constructor(
        private actions$: Actions,
        private annualRewardService: AnnualRewardService,
    ) {}
}
